import { LeagueConfig } from '@leagueplatform/cse-core';
import { AppTenant } from 'types';
import { ReferenceTenant } from './reference-tenant.config';
import { highmarkIEL } from './highmark-iel.config';
import { highmarkBeneficity } from './highmark-beneficity.config';
import { highmarkAllMyHealth } from './highmark-allmyhealth.config';

export const tenantSpecificConfigs = {
  [AppTenant.ReferenceTenant]: ReferenceTenant,
  [AppTenant.HighmarkIel]: highmarkIEL,
  [AppTenant.HighmarkBeneficity]: highmarkBeneficity,
  [AppTenant.HighmarkAllMyHealth]: highmarkAllMyHealth,
} satisfies Record<AppTenant, LeagueConfig>;

export type TenantId = keyof typeof tenantSpecificConfigs;
